import React from 'react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import BurgerIcon from 'assets/burger-icon.svg?react';
import { CustomMenu } from 'components/CustomMenu/CustomMenu';
import type { CustomMenuRow } from 'components/CustomMenu/CustomMenu';
import { EXTERNAL_LINKS } from 'resources/links';
import MenuLink from './MenuLink';
import { useMainNavigation } from './useMainNavigation';
import { useNavigationOverflow } from './useNavigationOverflow';

const openInNewTab = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');
const reloadState = () => ({ state: { reload: Date.now() } });

export const HeaderNav: React.FC = () => {
  const navigate = useNavigate();
  const { lotteryId, items, isActive, canReadContent } = useMainNavigation();
  const { containerRef, measureRef, burgerRef, visibleCount } = useNavigationOverflow(items.length, items.map((item) => item.path).join('|'));

  const [burgerAnchor, setBurgerAnchor] = React.useState<null | HTMLElement>(null);

  const goTo = (path: string) => {
    // Clicking the entry the user is already on reloads the page instead of doing nothing.
    navigate(path, isActive(path) ? reloadState() : undefined);
  };

  const supportItems: CustomMenuRow[] = [
    ...(lotteryId && canReadContent ? [{ name: 'Statistik', onClick: () => navigate(`/lottery/${lotteryId}/statistics`) }] : []),
    { name: 'Benutzerhandbuch', onClick: () => openInNewTab(EXTERNAL_LINKS.USER_MANUAL) },
    { name: 'Adminhandbuch', onClick: () => openInNewTab(EXTERNAL_LINKS.ADMIN_MANUAL) },
  ];

  const burgerItems: CustomMenuRow[] = [
    ...items.slice(visibleCount).map((item) => ({ name: item.label, onClick: () => goTo(item.path) })),
    ...supportItems,
  ];

  return (
    <nav className="psf-header-nav">
      <div className="psf-header-nav__container" ref={containerRef}>
        {items.slice(0, visibleCount).map((item) => (
          <MenuLink key={item.path} value={item.path} selected={isActive(item.path)} onClick={() => goTo(item.path)}>
            {item.label}
          </MenuLink>
        ))}

        <div className="psf-header-nav__burger" ref={burgerRef}>
          <IconButton
            onClick={(event) => setBurgerAnchor(event.currentTarget)}
            size="small"
            aria-label="Weitere Menüpunkte öffnen"
            aria-haspopup="true"
            aria-expanded={burgerAnchor ? 'true' : undefined}
          >
            <BurgerIcon width="27" height="24" />
          </IconButton>
        </div>
        <CustomMenu items={burgerItems} handleMenuClose={() => setBurgerAnchor(null)} withDivider anchorEl={burgerAnchor} width="527px" />

        <div className="psf-header-nav__measure" ref={measureRef} aria-hidden="true">
          {items.map((item) => (
            <MenuLink key={item.path} value={item.path} tabIndex={-1}>
              {item.label}
            </MenuLink>
          ))}
        </div>
      </div>
    </nav>
  );
};
